export type PopToastSeverity = 'error' | 'warning' | 'info' | 'success';

type ErrorPayload = {
    errorCode?: string;
    errorCodeKey?: string;
    detail?: string;
    correlationId?: string;
    message?: string;
    popToastNotification?: {
        message?: string;
        variant?: string;
    };
    textFieldErrors?: Array<{
        errorText?: string;
    }>;
};

export const extractApiErrorMessage = (payload: unknown, fallback = 'Request failed') => {
    if (!payload || typeof payload !== 'object') {
        return fallback;
    }

    const candidate = payload as ErrorPayload;

    if (typeof candidate.popToastNotification?.message === 'string' && candidate.popToastNotification.message.trim()) {
        return candidate.popToastNotification.message;
    }

    if (
        Array.isArray(candidate.textFieldErrors) &&
        typeof candidate.textFieldErrors[0]?.errorText === 'string' &&
        candidate.textFieldErrors[0].errorText.trim()
    ) {
        return candidate.textFieldErrors[0].errorText;
    }

    if (typeof candidate.message === 'string' && candidate.message.trim()) {
        return candidate.message;
    }

    return fallback;
};

export const extractApiErrorCode = (payload: unknown) => {
    if (!payload || typeof payload !== 'object') {
        return null;
    }

    return typeof (payload as ErrorPayload).errorCode === 'string' ? ((payload as ErrorPayload).errorCode ?? null) : null;
};

export const extractApiErrorCodeKey = (payload: unknown) => {
    if (!payload || typeof payload !== 'object') {
        return null;
    }

    return typeof (payload as ErrorPayload).errorCodeKey === 'string' ? ((payload as ErrorPayload).errorCodeKey ?? null) : null;
};

export const extractApiErrorDetail = (payload: unknown) => {
    if (!payload || typeof payload !== 'object') {
        return null;
    }

    return typeof (payload as ErrorPayload).detail === 'string' ? ((payload as ErrorPayload).detail ?? null) : null;
};

export const extractPopToastSeverity = (payload: unknown): PopToastSeverity => {
    if (!payload || typeof payload !== 'object') {
        return 'error';
    }

    const variant = (payload as ErrorPayload).popToastNotification?.variant;

    if (variant === 'warning' || variant === 'info' || variant === 'success' || variant === 'error') {
        return variant;
    }

    return 'error';
};
